<template>
  <v-skeleton-loader
    :loading="loading"
    type="image"
    max-height="64"
    :class="{ 'mb-2': loading }"
  >
    <slot />
  </v-skeleton-loader>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'DashboardTaskSkeleton',

  props: {
    loading: Boolean
  }
});
</script>
